<template>
    <div onselectstart="return false;" oncontextmenu="return false;" class="l-level-3d">
        <div class="l-level-sucker">
            <img class="sucker" src="./images/sucker.png" />
            <img class="level-select" src="./images/level-select.png" alt />
            <!-- 周 -->
            <div class="l-select-section">
                <span v-for="(item, idx) in weeks" :key="idx" @click="toogleWeek(item)" :class="{
                    active: currentWeek.id === item.id,
                    first: weeks.length !== 1 && idx === 0,
                    last: weeks.length !== 1 && idx === weeks.length - 1,
                }" class="l-select-type">第{{ item.weekId }}周</span>
            </div>
            <!-- 返回 -->
            <div @click="onBack" class="l-level-back"></div>
            <div class="l-menu-box">
                <div @click="onViewTask()" class="l-menu">任务</div>
                <LPreparation />
                <LRecord></LRecord>
                <LWork></LWork>
                <LLive></LLive>
                <AsideButton v-if="stage === '100'" @click="goXinfa" name="本周音频集"></AsideButton>
            </div>
            <!-- 推锁课时间 -->
            <div v-if="weeks && weeks.length > 0" class="l-lock-time">
                <p class="l-lock-time-text">
                    开启时间：{{ dayjs(currentWeek.startTime).format('YYYY-MM-DD') }} &nbsp;&nbsp; 锁定时间：{{ dayjs(currentWeek.endTime).format('YYYY-MM-DD') }}
                </p>
                <button v-if="delayCoupons.length > 0" class="l-lock-time-btn" @click="handleDelay">
                    <img src="./images/delay-button.png" alt />
                </button>
            </div>
        </div>
        <!-- 关卡 -->
        <div class="l-level-section">
            <div class="level-bar left"></div>
            <div class="level-bar right"></div>
            <div class="l-level-box" v-if="levels && levels.length > 0">
                <div v-for="item in levels" :key="item.id" class="l-level-list">
                    <div @click="onLesson(item)" class="l-pointer"></div>
                    <img class="list-bg" src="./images/list-bg.png" alt />
                    <div v-if="item.attrs.alias" class="l-list-title">{{ item.attrs.alias }}</div>
                    <div v-else class="l-list-title">{{ item.name }} - {{ item.parentName }}</div>
                    <div class="l-img">
                        <img class="data-img" :src="item.attrs.coverImage" alt />
                        <div v-if="item.done > 0 && !isNaN(item.star) && item.star !== null" class="l-star">
                            <LStar :options="item.star || 0" />
                        </div>
                        <div v-if="!item.lock && item.done === 0" class="l-ing">闯关ing</div>
                        <div v-if="item.done > 0" class="l-ing">已通关</div>
                    </div>
                    <div class="l-lock" v-if="item.lock"></div>
                </div>
            </div>
            <div class="l-level-box-no-data" v-else>
                <img class="no-data" src="./images/no-data.png" alt />
                <span>当前无关卡~</span>
            </div>
        </div>
        <!-- 任务 -->
        <LTask v-if="isShowTask" :data="weeks" @close="isShowTask = false" />
    </div>
</template>
  
<script>
import dayjs from 'dayjs'
import LPreparation from './components/l-preparation'
import Study2Model, {apiUseDelayCoupon} from '@/models/study2'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('course')
const { mapGetters, mapActions } = createNamespacedHelpers('assets')
import LStar from './components/star/star'
import LTask from './components/l-task'
import LRecord from './../record/record/index.vue'
import LWork from './../record/work/index.vue'
import LLive from './../record/live/index.vue'
import AsideButton from './components/aside-button.vue'
import lPrompt from '@/components/l-prompt'
import { CourseTypeMap } from '@/constants/enum'

const study2 = new Study2Model()
export default {
    name: 'level',
    components: {
        LStar,
        LPreparation,
        LTask,
        LRecord,
        LWork,
        LLive,
        AsideButton,
    },
    data () {
        return {
            dayjs,
            stage: 100, //   100：语课；101：阅课
            currentWeek: 0,
            levels: [],
            weeks: [],
            isShowTask: false,
        }
    },
    computed: {
        ...mapGetters(['delayCoupons']),
    },
    created () {
        this.stage = this.$route.query.stage || 100
        this._list()
        this.getUserAssets()
    },
    methods: {
        ...mapMutations(['SET_CURRENT_LESSON', 'RESET_LESSON', ]),
        ...mapActions(['getUserAssets']),
        onBack () {
            this.RESET_LESSON()
            //  返回
            this.$router.push({
                path: `/home`,
            })
        },
        onLesson (item) {
            if (item.lock) {
                return lPrompt({
                    message: '请先完成前面的关卡后，才能进入新关卡噢~',
                    successTxt: '确定',
                })
            }
            this.SET_CURRENT_LESSON({
                ...item,
                stage: this.stage,
                topId: this.currentWeek.id,
            })

            this.$router.push({
                path: `/lesson`,
                query: {
                    id: this.currentWeek.id,
                    dataId: item.id,
                },
            })
        },
        onViewTask () {
            this.isShowTask = true
        },
        toogleWeek (week) {
            this.currentWeek = week
            this.levels = week.lessons
        },
        async _list () {
            study2.lessons({ type: this.stage }).then((res) => {
                this.currentWeek = 0
                this.weeks = res.data
                this.toogleWeek(this.weeks?.[0]||{})
            })
        },
        goXinfa () {
            this.$router.push({
                path: `/xinfa`,
                query: {
                    stage: this.stage
                }
            })
        },
        handleDelay() {
            const coupon = this.delayCoupons[0]
            if (!coupon) {
                this.$lPrompt({
                    message: '请先购买延迟锁课券',
                    successTxt: '确定',
                })
                return
            }

            // <div><p>sss</p><p>ssss</p></div>
            const courseType = CourseTypeMap[this.stage]
            const endTime = dayjs(this.currentWeek.endTime).format('YYYY-MM-DD')
            const addTime = dayjs(this.currentWeek.endTime).add(7, 'day').format('YYYY-MM-DD')
            const message = this.$createElement('div', { style: {
                color: '#FF8D1A',
                fontSize: '14px',
            } }, [
                this.$createElement(
                    'p',
                    `使用“关卡延锁券” 后，本周${courseType}关卡的锁定时间将从${endTime}延长7天至${addTime}`
                ),
            ])

            this.$lPrompt({
                message: message,
                cancelTxt: "取消",
                successFn: async () => {
                    try {
                        await apiUseDelayCoupon({
                            userPropId: coupon.id,
                            recordId: this.currentWeek.id,
                        })
                        this.$lPrompt({
                            message: `延时成功，${courseType}关卡的锁定时间延长至${addTime}`,
                            successTxt: '确定',
                        })
                        this._list()
                        this.getUserAssets()
                    } catch (error) {
                        const errmsg = error.msg || '延时失败'
                        this.$lPrompt({
                            message: errmsg.slice(6), // 格式化，去掉错误码，只保留错误信息
                            successTxt: '确定',
                        })
                    }
                },
                cancelFn: () => {},
            })
        }
    },
}
</script>
<style lang="stylus" scoped>
@import 'index.styl'

.l-lock-time {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    padding: 4px 32px;
    border-radius: 40px;
    background-color: #1c2b75;
    color: #86e5fd;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -24px;
    z-index: 10;

    .l-lock-time-text {
        margin: 0;
        font-size: 20px;
        color: #fff;
    }

    .l-lock-time-btn {
        width: 120px;
        height: 40px;
        margin-left: 12px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
